import React, { useState } from "react";
import { DateContext } from "./DateContext";

interface Props {
  children: any;
}

function getPastFriday() {
  const today = new Date();
  const dayOfWeek = today.getDay(); // 0 = Sun, 1 = Mon, ..., 5 = Fri, 6 = Sat

  // Days to subtract to get to last Friday
  const daysToFriday = dayOfWeek >= 5 ? dayOfWeek - 5 : dayOfWeek + 2;

  const lastFriday = new Date(today);
  lastFriday.setDate(today.getDate() - daysToFriday);
  return lastFriday;
}

export default function UserProvider(props: Props) {


  const [selectedDate, setSelectedDate] = useState<Date | null>(getPastFriday());


  return (
    <DateContext.Provider value={{  selectedDate, setSelectedDate  }}>
      {props.children}
    </DateContext.Provider>
  );
}
